"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoeLoginUrlResponseToJSON = exports.JoeLoginUrlResponseFromJSONTyped = exports.JoeLoginUrlResponseFromJSON = void 0;
function JoeLoginUrlResponseFromJSON(json) {
    return JoeLoginUrlResponseFromJSONTyped(json, false);
}
exports.JoeLoginUrlResponseFromJSON = JoeLoginUrlResponseFromJSON;
function JoeLoginUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': json['url'],
    };
}
exports.JoeLoginUrlResponseFromJSONTyped = JoeLoginUrlResponseFromJSONTyped;
function JoeLoginUrlResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
    };
}
exports.JoeLoginUrlResponseToJSON = JoeLoginUrlResponseToJSON;
//# sourceMappingURL=JoeLoginUrlResponse.js.map